import { render } from "./BillingPaymentResult.vue?vue&type=template&id=651f6d36"
import script from "./BillingPaymentResult.vue?vue&type=script&lang=js"
export * from "./BillingPaymentResult.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__